import type { MergeKeep } from './api'

/**
 * The distinct assignments a set of creatives carries, as the merge route counts them
 * (GRO-161): a creative without a hypothesis carries none, and under one hypothesis a
 * letter covers its absence. One needs no choice; two or more need the reader to pick the
 * one the merged row keeps. Sorted by hypothesis id, then letter.
 */
export function distinctAssignments(
  rows: readonly { hypothesisId: string | null; versionLabel: string | null }[],
): MergeKeep[] {
  const letters = new Map<string, Set<string>>()
  for (const row of rows) {
    if (row.hypothesisId === null) continue
    const set = letters.get(row.hypothesisId) ?? new Set<string>()
    if (row.versionLabel !== null) set.add(row.versionLabel)
    letters.set(row.hypothesisId, set)
  }
  const out: MergeKeep[] = []
  for (const hypothesisId of [...letters.keys()].sort()) {
    const versions = [...(letters.get(hypothesisId) ?? [])].sort()
    if (versions.length === 0) out.push({ hypothesisId, version: null })
    for (const version of versions) out.push({ hypothesisId, version })
  }
  return out
}
